<mat-toolbar class="mat-elevation-z4">
  <span fxFlex>Avisos</span>
</mat-toolbar>

<div *ngIf="errorMessage" class="error-message">
  <span>{{ errorMessage }}</span>
</div>

<div *ngIf="!errorMessage && alerts.length === 0" class="empty-state">
  No hay avisos para hoy.
</div>

<p-table
  [value]="alerts"
  responsiveLayout="scroll"
  tableStyleClass="mat-elevation-z4"
  [rows]="100">

  <ng-template pTemplate="header">
    <tr>
      <th>ID</th>
      <th>Tipo de aviso</th>
      <th>Estado</th>
      <th>Partido judicial</th>
      <th>Solicitante</th>
      <th>Inicio</th>
      <th>Llamadas</th>
    </tr>
  </ng-template>

  <ng-template pTemplate="body" let-alert>
    <tr>
      <td>{{ alert.id }}</td>
      <td>{{ alert.alertTypeName | titlecase }}</td>
      <td>{{ alert.status }}</td>
      <td>{{ alert.judicialDistrict | titlecase }}</td>
      <td>{{ alert.requestedByUserName | titlecase }}</td>
      <td>{{ alert.start | date: 'dd/MM/YYYY HH:mm' }}</td>
      <td>{{ alert.numCalls }}</td>
    </tr>
  </ng-template>

</p-table>
